import { Component, effect, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Faction, Prototype, Aspect } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';


@Component({
    selector: 'app-aspect-node',
    templateUrl: './aspect-node.component.html',
    styleUrls: ['./aspect-node.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AspectNodeComponent extends NodeComponent {
    protected get nodeType(): string | undefined {
        return 'aspect';
    }

    private iconRoot = 'account_tree';
    private iconFaction = 'widgets';
    private iconPrototype = 'insert_drive_file';
    private iconAspect = 'extension';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model) {
                if (model.node instanceof Faction) {
                    if (model.node.parentId) {
                        this.icon = this.iconFaction;
                    } else {
                        this.icon = this.iconRoot;
                    }
                } else if (model.node instanceof Prototype) {
                    this.icon = this.iconPrototype;
                } else if (model.node instanceof Aspect) {
                    this.icon = this.iconAspect;
                }
            }
        });
    }
}
